import React, {useMemo} from 'react';
import {FullTextSearchRegulationsQuery} from 'features/Search/hooks';
import {SearchResultRegulation} from 'features/Search/components/SearchCards/SearchResultCards';
import {Regulation} from 'types';
import {useRegulationsPageColumn} from 'features/Regulations/RegulationsPageColumns';
import {RegulationsTooltipTranslationProvider} from 'features/Regulations/components/RegulationsTooltipTranslationProvider';
import {getEntityListColumns, SearchResult} from './SearchResult';

const entityName = 'Regulations';
const primitiveColumns: string[] = [];
const arrayColumns: string[] = [
	'markets',
	'mainKeywords',
	'keywords',
	'standardPlusPcmsClusters',
];
const dateColumns: string[] = [];
const omitColumns: string[] = ['attachments'];
const quickFilterColumns: string[] = arrayColumns;

type RegulationSearchResultProps = {
	currentViewKey: string;
	isResultCardFormat: boolean;
	loading: boolean;
	regulationData: FullTextSearchRegulationsQuery | undefined;
};

export const RegulationSearchResult: React.FC<
	RegulationSearchResultProps
> = props => {
	const columnsInfinity = useRegulationsPageColumn();

	const propsResult = useMemo(() => {
		const columns = getEntityListColumns(
			columnsInfinity,
			primitiveColumns,
			arrayColumns,
			dateColumns,
			omitColumns,
		);

		const searchedItems =
			props.regulationData?.searchRegulations.regulations || [];

		const renderCard = (item: Regulation) => (
			<SearchResultRegulation key={item.id} item={item} />
		);

		const renderEntityList = (EntityList: JSX.Element) => {
			return (
				<RegulationsTooltipTranslationProvider>
					{EntityList}
				</RegulationsTooltipTranslationProvider>
			);
		};

		return {
			...props,
			entityName,
			searchedItems,
			columns,
			quickFilterColumns,
			renderCard,
			renderEntityList,
		};
	}, [props]);

	return <SearchResult {...propsResult} />;
};
